<div class="qr-scanner"
  [class.loading]="qrScannerEnabled">

  @if (!qrScannerEnabled) {
    <mat-icon
      class="xl"
      (click)="enableQrScanner()">
      qr_code_scanner
    </mat-icon>
  }

  @if (qrScannerEnabled) {
    <zxing-scanner
      (scanSuccess)="onQrScanSuccess($event)"
      (scanError)="onQrScanError()"
      (camerasNotFound)="onQrNoCamerasFound()"
      (permissionResponse)="onQrCameraPermission($event)">
    </zxing-scanner>
  }
</div>
